/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Optimization icon.
 */
export const ICON_CAPABILITY_OPTIMIZATION = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 23.9793V28.6215L14.8697 23.7438C15.4742 23.1394 16.4507 23.1394 17.0551 23.7438L22.1544 28.8431L32.0584 17.7146C32.6473 17.0482 33.6858 17.0327 34.3058 17.6526C34.8792 18.2416 34.9102 19.1716 34.3678 19.776L23.2548 32.2839C22.6658 32.9504 21.6429 32.9814 21.0074 32.3459L15.9702 27.3086L10.494 32.7848C11.6219 35.8359 14.557 38.0109 18 38.0109H30C34.4183 38.0109 38 34.4292 38 30.0109V18C38 14.9952 36.3435 12.3774 33.8938 11.0099L23.2548 22.9844C22.6658 23.6508 21.6429 23.6818 21.0074 23.0464L15.9702 18.0091L10 23.9793Z"
      fill="#1D9BE2"
    />
    <path
      d="M30.6263 10.0242C30.4197 10.0082 30.2108 10 30 10H18C13.5817 10 10 13.5817 10 18V19.322L14.8697 14.4443C15.4742 13.8398 16.4507 13.8398 17.0551 14.4443L22.1544 19.5435L30.6263 10.0242Z"
      fill="#1D9BE2"
    />
    <path
      clipRule="evenodd"
      d="M6.99463 32.5054C6.99463 37.1998 10.8002 41.0054 15.4946 41.0054L20.2989 41.0054C21.1273 41.0054 21.7989 41.6769 21.7989 42.5054C21.7989 43.3338 21.1273 44.0054 20.2989 44.0054L15.4946 44.0054C9.14336 44.0054 3.99463 38.8566 3.99463 32.5054L3.99463 15.4946C3.99463 9.14336 9.14335 3.99463 15.4946 3.99463L20.2989 3.99463C21.1273 3.99463 21.7989 4.6662 21.7989 5.49463C21.7989 6.32305 21.1273 6.99463 20.2989 6.99463L15.4946 6.99463C10.8002 6.99463 6.99463 10.8002 6.99463 15.4946L6.99463 32.5054Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M41.0054 32.5054C41.0054 37.1998 37.1998 41.0054 32.5054 41.0054L29.5516 41.0054C28.7232 41.0054 28.0516 41.6769 28.0516 42.5054C28.0516 43.3338 28.7232 44.0054 29.5516 44.0054L32.5054 44.0054C38.8566 44.0054 44.0054 38.8566 44.0054 32.5054L44.0054 15.4946C44.0054 9.14336 38.8566 3.99463 32.5054 3.99463L29.5516 3.99463C28.7232 3.99463 28.0516 4.6662 28.0516 5.49463C28.0516 6.32306 28.7232 6.99463 29.5516 6.99463L32.5054 6.99463C37.1998 6.99463 41.0054 10.8002 41.0054 15.4946L41.0054 32.5054Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);
